// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const absol: PokeData = {
  "id": 359,
  "name": "absol",
  "height": 12,
  "weight": 470,
  "base_experience": 163,
  "types": [
    PokeType.DARK
  ],
  "api_moves": [
    "scratch",
    "razor-wind",
    "swords-dance",
    "leer",
    "bite",
    "quick-attack",
    "double-team",
    "focus-energy",
    "slash",
    "perish-song",
    "detect",
    "pursuit",
    "future-sight",
    "taunt",
    "knock-off",
    "feint",
    "me-first",
    "sucker-punch",
    "night-slash",
    "psycho-cut"
  ],
  "moves": [
    "scratch",
    "leer",
    "bite",
    "quick-attack",
    "pursuit",
    "future-sight",
    "night-slash",
    "dark-bargain",
    "lash-out",
    "crunch",
    "snatch",
    "flatter",
    "night-daze"
  ],
  "evolution_chain": {
    "id": 185,
    "item": null,
    "species": [
      {
        "name": "absol",
        "order": 389,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 93,
    "speed": 112,
    "ability_power": 194
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
